import { render, staticRenderFns } from "./UserManagement.vue?vue&type=template&id=00054031&scoped=true&lang=html&"
import script from "./UserManagement.vue?vue&type=script&lang=ts&"
export * from "./UserManagement.vue?vue&type=script&lang=ts&"
import style0 from "./UserManagement.vue?vue&type=style&index=0&id=00054031&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00054031",
  null
  
)

export default component.exports